export enum STEPS {
    Initial,
    EditConfiguration
}
